import { Card } from '@mui/material'
import Grid from '@mui/material/Grid'

import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { useMaterialUIController } from 'context/materialUI'
import FeedbackMemberOptions from 'layouts/configuration/feedback/components/FeedbackMemberOptions'

import CustomerOutcomes from '../CustomerOutcomes'

function MainContent() {
	const [controller] = useMaterialUIController()
	const { configuration } = controller
	const memberTypes = configuration?.organisation.memberTypes

	return (
		<Grid container spacing={3}>
			{memberTypes?.map((mT, index) => {
				return (
					<MDBox key={index} ml={4} mt={4} gap={3} display="flex" flexDirection="column">
						<MDTypography id={mT.name.toLowerCase()} variant="h3">
							{mT.name}
						</MDTypography>
						<Grid item xs={12}>
							<FeedbackMemberOptions name="COMPLAINT" memberType={mT.name} />
						</Grid>
						<Grid item xs={12}>
							<FeedbackMemberOptions name="COMMENDATION" memberType={mT.name} />
						</Grid>
					</MDBox>
				)
			})}
			{memberTypes?.length === 0 && (
				<Grid item xs={12}>
					<Card variant="outlined" sx={{ borderColor: '#e0e0e0' }}>
						<MDBox p={3} textAlign="center">
							<MDTypography variant="h4" gutterBottom>
								No Members Configured
							</MDTypography>
							<MDTypography variant="body2">
								To start setting up organisation member complaint and commendation categories,
								please configure the feedback members in the
								<strong> Configuration &gt; Organisation </strong> section.
							</MDTypography>
						</MDBox>
					</Card>
				</Grid>
			)}

			<Grid item xs={12}>
				{<CustomerOutcomes />}
			</Grid>
		</Grid>
	)
}

export default MainContent
